import React, { useState, useEffect } from "react";
import BreadTable from "./BreadTable";
import SearchBar from "../common/SearchBar";
import { useBreadOrders } from '../../hooks';
import styles from "./Bread.module.css";

export default function SearchBreadOrders() {
    const [all, setAll] = useState(false);
    const { orders: breadOrders, loading } = useBreadOrders(all);
    const [filteredOrders, setFilteredOrders] = useState([]);

    useEffect(() => {
        setFilteredOrders(breadOrders);
    }, [breadOrders]);

    function onSearch(query) {
        if (query === '') {
            setFilteredOrders(breadOrders);
            return;
        }
        const filteredData = breadOrders.filter(bread =>
            bread.firstName.toLowerCase().includes(query.toLowerCase()) ||
            bread.cashier.toLowerCase().includes(query.toLowerCase()) ||
            bread.date.toLowerCase().includes(query.toLowerCase())
        );
        setFilteredOrders(filteredData);
    }

    return (
        <div className="basicContainer">
            <div className={styles.searchResultsBread}>
                <h1>Ordenes de Pan</h1>
                <hr />
                <SearchBar onSearch={onSearch} />
                {loading ? <p>Loading...</p> : (
                    <BreadTable
                        loading={loading}
                        breadOrders={filteredOrders}
                    />
                )}
                <button onClick={() => setAll(!all)}>
                    {all ? "Ver solo hoy" : "Ver todos"}
                </button>
            </div>
        </div>
    );
}
